import React from 'react';
import dayjs from 'dayjs';
import {Box, Card, Stack, Typography} from '@mui/material';
import {grey} from '@mui/material/colors';
import {EdgeBilling} from 'app/components/entities/billing/edge';
import {formatPrice} from 'app/components/entities/billing/base';
import {StyleSx, Sx} from 'app/types/common';
import {packSx} from 'app/util/packSx/packSx';

const rootSx: StyleSx = {p: 5, bgcolor: grey[50]};

interface Props extends Sx {
  invoice: EdgeBilling.Invoice;
}

export function EdgeInvoice({sx, invoice}: Props) {
  return (
    <Card data-id="edge-invoice" sx={packSx(rootSx, sx)} variant="outlined">
      <Stack mb={1} direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="h5" fontWeight={600}>
          Upcoming invoice
        </Typography>

        <Typography data-id="invoice-period" color="text.secondary">
          {dayjs.unix(invoice.periodStart).format('ll')} -{' '}
          {dayjs.unix(invoice.periodEnd).format('ll')}
        </Typography>
      </Stack>

      <Typography data-id="invoice-date" mb={2} color="primary.main">
        Will be issued on: {dayjs.unix(invoice.date).format('LL')}
      </Typography>

      <Stack mb={1} gap={2}>
        <Stack direction="row" justifyContent="space-between">
          <Box>
            <Typography fontSize={16}>Edge subscription</Typography>
            <Typography>Edge usage in period.</Typography>
          </Box>

          <Typography data-id="edge-price" fontSize={16} fontWeight={600}>
            {formatPrice(invoice.total, 2)}
          </Typography>
        </Stack>
      </Stack>

      <Typography
        data-id="invoice-total"
        fontSize={16}
        color="primary.main"
        textAlign="right"
        fontWeight={600}
      >
        Total period amount: {formatPrice(invoice.total, 2)}
      </Typography>
    </Card>
  );
}
